import * as React from 'react';
import { Dialog, DialogType, DialogFooter, DialogContent } from '@fluentui/react/lib/Dialog';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { useBoolean } from '@fluentui/react-hooks';
import { Text } from "@fluentui/react";

const modalPropsStyles = { main: { maxWidth: '50rem' } };
const dialogContentProps = {
  type: DialogType.normal,
  title: 'There was an error processing your request.',
  subText: 'Please see details below.'
};

const ExceptionDialog = (props) => {
  const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
  const { showExceptionDialog, setShowExceptionDialog, exceptionMessage } = props;

  const modalProps = React.useMemo(
    () => ({
      isBlocking: true,
      styles: modalPropsStyles,
      dragOptions: false,
    }),
    [],
  );

  function onCloseDialog() {
      if(showExceptionDialog == true) {
        setShowExceptionDialog(false);
      }
  }


  return (
    <>
      <Dialog
        hidden={!showExceptionDialog}
        onDismiss={onCloseDialog}
        dialogContentProps={dialogContentProps}
        modalProps={modalProps}
      >
          <DialogContent>
          <b><Text style={{color: 'red'}}>{exceptionMessage}</Text></b>
          </DialogContent>
        <DialogFooter>
          <PrimaryButton onClick={onCloseDialog} text="Ok" />
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default ExceptionDialog;
